<template>
    <!-- <v-parallax src="../assets/survey.jpg" height="1300"> -->
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="user-survey">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm12 md11 lg10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>{{ $t('msg-bienvenido') }} {{ userName }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- <v-toolbar-title v-if="sessionExpires">
                            <div v-if="!sessionEnding" class="caption">Tiempo restante: {{ timeLeftToPrint }}</div>
                            <div v-else class="caption font-weight-bold pink--text text--lighten-3">Tiempo restante: {{ timeLeftToPrint }}</div>
                        </v-toolbar-title> -->
                    </v-toolbar>

                    <!-- Container para contenido principal: -->
                    <v-container grid-list-md fluid>
                        <v-layout row wrap justify-space-around>
                            <v-flex xs9 md5 class="text-center">
                                <img :height="logoHeight" :src="companyLogoImg"/>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-space-around>
                            <v-flex xs9 md5 class="text-center title font-weight-bold brown--text text--darken-4">
                                {{ companyName }}
                            </v-flex>
                        </v-layout>
                        <br />

                        <v-layout row wrap justify-space-around>
                            <v-flex xs10 sm8 md6 class="text-center">
                                <v-progress-linear
                                    v-model="surveyProgress"
                                    height="20"
                                    color="orange accent-4"
                                >
                                    <strong>{{ Math.round(surveyProgress) }}%</strong>
                                </v-progress-linear>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-space-around>
                            <v-flex xs12 class="text-center deep-orange--text text--darken-4">
                                {{ $t('lbl-avance') }}
                            </v-flex>
                        </v-layout>
                        <br />
                        <v-divider></v-divider>
                        <v-layout row wrap justify-space-around>
                            <v-flex
                                xs12
                                class="text-center font-weight-bold teal--text text--darken-3"
                                >{{ $t('msg-encuesta-evalua-a') }} {{ userSurveyData.evaluado }}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <br />
                        <div v-if="moduleTitle !== ''">
                            <v-layout>
                                <v-flex
                                    xs12
                                    class="text-left font-weight-bold cyan--text text--darken-4 headline"
                                    >{{ moduleTitle }}</v-flex
                                >
                            </v-layout>
                            <v-divider class="cyan darken-4"></v-divider>
                            <br />
                        </div>

                        <div v-if="groupTitle !== ''">
                            <v-layout>
                                <v-flex
                                    xs12
                                    class="text-left font-weight-bold cyan--text text--darken-3 title"
                                    >{{ groupTitle }}</v-flex
                                >
                            </v-layout>
                            <v-divider class="cyan darken-3"></v-divider>
                            <br />
                        </div>

                        <div v-for="(question, i) in questionsToShow" :key="question.numPregunta">
                            <!-- Pregunta de opción múltiple: -->
                            <div v-if="question.tipo === 1">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">
                                        <span style="color: rgb(0, 105, 92)"
                                            >{{ question.numPregunta }})&nbsp;
                                        </span>
                                        {{ question.pregunta }}
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex xs11 class="offset-xs1">
                                        <v-radio-group
                                            :column="$vuetify.breakpoint.smAndDown"
                                            :row="$vuetify.breakpoint.mdAndUp"
                                            v-model="question.respuestaUsuario"
                                        >
                                            <!-- Para agregar tooltips a cada respuesta:  -->
                                            <div v-for="(answer, j) in question.respuestas">
                                                <div v-if="(answer.tooltip !== null) && (answer.tooltip !== '')">
                                                    <!-- <v-tooltip bottom max-width="500"  color="amber lighten-3"> -->
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span v-bind="attrs" v-on="on">
                                                                <v-radio
                                                                    :key="answer.num"
                                                                    :label="answer.texto"
                                                                    :value="answer.num"
                                                                    @change="onSelectAnswer({answer, question})"
                                                                    color="orange accent-4"
                                                                ></v-radio>
                                                            </span>
                                                        </template>
                                                        <span>
                                                            {{ answer.tooltip }}
                                                        </span>
                                                    </v-tooltip>
                                                </div>
                                                <div v-else>
                                                    <v-radio
                                                        :key="answer.num"
                                                        :label="answer.texto"
                                                        :value="answer.num"
                                                        @change="onSelectAnswer({answer, question})"
                                                        color="orange accent-4"
                                                    ></v-radio>
                                                </div>
                                            </div>
                                            
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <!-- Pregunta con respuestas etiquetadas como "alternativas": -->
                            <div v-else-if="question.tipo === 2">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">{{
                                        question.pregunta
                                    }}</v-flex>
                                </v-layout>
                                <v-radio-group
                                    row
                                    v-model="question.respuestaUsuario"
                                >
                                    <div v-for="(answer, j) in question.respuestas" :key="answer.num">
                                        <br />
                                        <v-layout row>
                                            <v-flex
                                                xs2
                                                class="text-right font-weight-bold cyan--text text--darken-4"
                                                >{{ $t('lbl-alternativa') }}
                                                {{ answer.num }}:</v-flex
                                            >
                                            <v-flex xs10>
                                                <v-radio
                                                    :label="answer.texto"
                                                    :value="answer.num"
                                                    @change="onSelectAnswer({answer, question})"
                                                    color="orange accent-4"
                                                ></v-radio>
                                            </v-flex>
                                        </v-layout>
                                        <br />
                                    </div>
                                </v-radio-group>
                            </div>
                            <!-- Pregunta con respuestas a ordenar: -->
                            <div v-else-if="question.tipo === 3">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">{{
                                        question.pregunta}}</v-flex>
                                </v-layout>

                                <v-layout v-for="(answer, j) in orderedAnswers(question.respuestas)" :key="answer.respuesta">
                                    <v-flex xs3 md2 class="text-right">
                                        <span style="color: rgb(0, 105, 92); font-weight: bold;">
                                            {{ answer.respuesta }})&nbsp;
                                        </span>
                                        &nbsp;
                                        <v-btn
                                            color="green darken-2"
                                            fab
                                            dark
                                            x-small
                                            @click="onUp(question, answer)"
                                            :disabled="answer.respuesta === '1'"
                                        >
                                            <v-icon>mdi-arrow-up-circle</v-icon>
                                        </v-btn
                                        >&nbsp;
                                        <v-btn
                                            color="red darken-3"
                                            fab
                                            dark
                                            x-small
                                            @click="onDown(question, answer)"
                                            :disabled="j === question.respuestas.length - 1"
                                        >
                                            <v-icon>mdi-arrow-down-circle</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs9 md10 class="text-left">{{ answer.texto }}</v-flex>
                                </v-layout>
                                <br />
                            </div>
                            <!-- Pregunta con respuesta de texto libre: -->
                            <div v-else-if="question.tipo === 4">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">{{
                                        question.pregunta
                                    }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-textarea
                                            dense
                                            outlined
                                            v-model="question.respuestas[0].respuesta"
                                            :auto-grow="false"
                                            no-resize
                                            color="cyan darken-3"
                                            rows="5"
                                            :counter="iMaxCharacters"
                                            :rules="commentLengthRules"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <!-- Pregunta de selección múltiple: -->
                            <div v-else-if="question.tipo === 5">
                                <v-layout row>
                                    <v-flex xs12 class="font-weight-bold">
                                        <span style="color: rgb(0, 105, 92)"
                                            >{{ question.numPregunta }})&nbsp;
                                        </span>
                                        {{ question.pregunta }}
                                    </v-flex>
                                </v-layout>

                                <div v-for="(answer, j) in question.respuestas">
                                    <v-flex xs11 sm6 class="offset-xs1">
                                        <div v-if="answer.tooltip !== null">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                        <v-checkbox
                                                            class="ma-0"
                                                            :key="answer.num"
                                                            :label="answer.texto"
                                                            v-model="answer.respuesta"
                                                            color="orange accent-4"
                                                            dense
                                                        ></v-checkbox>
                                                    </span>
                                                </template>
                                                <span>
                                                    {{ answer.tooltip }}
                                                </span>
                                            </v-tooltip>
                                        </div>
                                        <div v-else>
                                            <v-checkbox
                                                class="ma-0"
                                                :key="answer.num"
                                                :label="answer.texto"
                                                v-model="answer.respuesta"
                                                color="orange accent-4"
                                                dense
                                            ></v-checkbox>
                                        </div>
                                    </v-flex>      
                                </div>
                            </div>
                            <v-divider></v-divider>
                            <br />
                        </div>
                        <v-layout align-center justify-end row fill-height>
                            <v-flex xs12 sm8 class="text-xs-center text-end">
                                <v-btn
                                    color="pink accent-3"
                                    class="text-none"
                                    text
                                    @click="onPrev"
                                    :disabled="!bShowPrevButton"
                                >
                                    <v-icon color="pink accent-3">mdi-chevron-left</v-icon>
                                    {{ $t('btn-regresar') }}
                                </v-btn>
                                <v-btn
                                    v-if="bShowNextButton"
                                    color="cyan darken-3"
                                    class="text-none"
                                    text
                                    @click="onNext"
                                >
                                    {{ $t('btn-continuar') }}
                                    <v-icon color="cyan darken-3">mdi-chevron-right</v-icon>
                                </v-btn>
                                
                                <v-btn
                                    v-else
                                    color="cyan darken-3"
                                    class="text-none"
                                    text
                                    @click="onSend"
                                    :disabled="bSurveySent"
                                >
                                    {{ $t('btn-finalizar') }} &nbsp;
                                    <v-icon color="cyan darken-3">mdi-check</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <!-- Modal para Disclaimer: **************************************** -->
                        <v-layout v-if="bShowDisclaimer" row justify-center>
                            <v-dialog
                                v-model="bShowDisclaimer"
                                persistent
                                :width="disclaimerWidth"
                            >
                                <v-card class="grey darken-4">
                                    <v-img
                                        :src="disclaimerImg"
                                        class="align-end"
                                        width="100%"
                                        gradient="to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0.87)"
                                    >
                                        <v-card-text class="cyan--text text--darken-3 headline text-center">
                                            <img
                                                height="150"
                                                :src="retroalimentameLogo"
                                            />
                                            <br />
                                            <b>Talentwise SC, México, Consultoría empresarial</b>
                                        </v-card-text>
                                        <v-card-text class="teal--text text--lighten-4 body-2">
                                            <!-- Si deseas consultar nuestro aviso de privacidad desarrollado conforme a la legislación aplicable en México, lo podrás hacer haciendo clic aquí: -->
                                            {{ $t('msg-aviso-privacidad')}}
                                        </v-card-text>
                                        <v-card-text class="text-center">
                                            <v-btn
                                                color="cyan darken-2"
                                                class="text-none"
                                                text
                                                @click="privacy">
                                                <!-- Aviso de Privacidad -->
                                                {{ $t('btn-aviso-privacidad') }}
                                            </v-btn>
                                        </v-card-text>    
                                         <v-card-text class="teal--text text--lighten-4 body-2">
                                            <!-- No guardamos cookies para ningún motivo comercial. Utilizamos la información esencial para el procesamiento de nuestros reportes. El propósito de nuestro trabajo es diseñar herramientas que apoyen a nuestros clientes en sus estrategias de desarrollo de talento para sus organizaciones. No enviamos correos promocionales ni nada semejante con la información que nuestros usuarios nos comparten. -->
                                            {{ $t('msg-no-cookies') }}
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="cyan darken-2"
                                                class="text-none"
                                                text
                                                @click="onCloseDisclaimer"
                                                >{{ $t('btn-aceptar') }}</v-btn
                                            >
                                            <v-btn
                                                color="pink accent-1"
                                                class="text-none"
                                                text
                                                @click="onExit"
                                                >{{ $t('btn-salir') }}</v-btn
                                            >
                                        </v-card-actions>
                                    </v-img>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para Disclaimer *************************** -->
                        <!-- Modal para Introducción: **************************************** -->
                        <v-layout v-else row justify-center>
                            <v-dialog
                                v-model="showIntro"
                                persistent
                                :width="modalWidth"
                            >
                                <v-card class="grey darken-4">
                                    <v-card-text class="cyan--text text--darken-3 headline text-center">
                                        <img height="170" :src="retroalimentameLogo"/>
                                        <br />
                                        <b>Talentwise SC, México, Consultoría empresarial</b>
                                    </v-card-text>
                                    <v-card-text class="teal--text text--lighten-4 text-sm-left enter-line">
                                        {{ userSurveyData.intro }}
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="cyan darken-2"
                                            class="text-none"
                                            text
                                            @click="onBegin"
                                            >{{ $t('btn-comenzar') }}</v-btn
                                        >
                                        <v-btn
                                            color="pink accent-1"
                                            class="text-none"
                                            text
                                            @click="onExit"
                                            >{{ $t('btn-salir') }}</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para Introducción *************************** -->

                        <!-- Modal para pedir el nombre y apellido para el reporte (en encuestas masivas): *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgAskForName"
                                persistent
                                :width="nameReportModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container>    
                                        <v-layout align-center justify-center>
                                            <v-flex xs10>
                                                <div class="tw-green title font-weight-medium">
                                                    {{ $t('msg-escriba-el-nombre-para-el-reporte') }}
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                        <br>
                                        <v-layout align-center justify-center>
                                            <v-flex xs10>
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                            </v-flex>
                                        </v-layout>
                                        <br>
                                        <v-layout align-center justify-center>
                                            <v-flex xs10>
                                                <v-text-field
                                                    dense
                                                    color="teal darken-1"
                                                    :label="$t('lbl-nombre')"
                                                    type="text"
                                                    v-model="userSurveyData.nombre"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout align-center justify-center>
                                            <v-flex xs10>
                                                <v-text-field
                                                    dense
                                                    color="teal darken-1"
                                                    :label="$t('lbl-apellidos')"
                                                    type="text"
                                                    v-model="userSurveyData.apellido"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal"
                                            class="text-none"
                                            text
                                            @click="confirmUserName"
                                            :disabled = "((userSurveyData.nombre === '') || (userSurveyData.apellido === ''))"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir el nombre y apellido para el reporte (en encuestas masivas) *********************************** -->


                        <!-- Modal para preguntar si se desea evaluar a subordinados: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="subordinatedDlg"
                                persistent
                                :width="modalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="teal lighten-3"
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title">{{ $t('lbl-colaboradores') }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-account-hard-hat</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout row wrap>
                                                <v-flex
                                                    xs4
                                                    class="teal--text text--darken-3 body-1 font-weight-bold"
                                                    >{{ $t('quest-desea-evaluar-subordinados') }}
                                                </v-flex>

                                                <v-flex xs8 class="text-right">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onAddSubordinated"
                                                        :disabled="subordinated === '0'"
                                                        >{{ $t('btn-agregar-subordinado') }}</v-btn
                                                    >
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onEditSubordinated"
                                                        :disabled="selectedSubordinated.length === 0"
                                                        >{{ $t('btn-editar-subordinado') }}</v-btn
                                                    >
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onDeleteSubordinated"
                                                        :disabled="selectedSubordinated.length === 0"
                                                        >{{ $t('btn-borrar-subordinado') }}</v-btn
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs11 class="offset-xs1">
                                                    <v-radio-group
                                                        row
                                                        v-model="subordinated"
                                                    >
                                                        <v-radio
                                                            label="Sí"
                                                            value="1"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="No tengo subordinados"
                                                            value="0"
                                                            color="orange accent-4"
                                                            @change="onNoSubordinated"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-data-table
                                                        fixed-header
                                                        :headers="subordinatedHeader"
                                                        :items="subordinatedArray"
                                                        single-select
                                                        item-key="ID"
                                                        v-model="selectedSubordinated"
                                                        locale="es-MX"
                                                        hide-default-footer
                                                        :no-data-text="$t('lbl-no-subordinados')"
                                                        show-select
                                                        dense
                                                        :items-per-page="subordinatedArray.length"
                                                    >
                                                    </v-data-table>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onSubordinatedOK"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para preguntar si se desea evaluar a subordinados *************************** -->

                        <!-- Modal para agregar o editar un subordinado: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="addSubordinatedDlg"
                                persistent
                                :width="miniModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="teal lighten-3"
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title"
                                            >{{ $t('btn-agregar-editar-subordinado') }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-account-tie</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account-tie"
                                                        :label="$t('lbl-nombre-completo')"
                                                        type="text"
                                                        v-model="subordinatedToAdd.name"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex
                                                    xs7
                                                    sm5
                                                    md3
                                                    class="text-left"
                                                >
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-alphabetical"
                                                        label="Iniciales"
                                                        type="text"
                                                        v-model="subordinatedToAdd.initials"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmSubordinatedEdition"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelSubordinatedEdition"
                                            >{{ $t('btn-cancelar') }}</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para agregar o editar a un subordinado *************************** -->

                        <!-- Modal para pedir que se escriba el nombre y las iniciales del subordinado a editar/agregar: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="dlgSubordinatedError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/pleaseanswer.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-text
                                                    class="teal--text text--lighten-2 headline text-center"
                                                >
                                                    <img
                                                        height="90"
                                                        :src="retroalimentameLogo"
                                                    />
                                                    <br />
                                                    <br />
                                                </v-card-text>
                                                <v-layout row justify-center>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-icon
                                                            x-large
                                                            color="orange darken-1"
                                                            >mdi-alert-circle-outline</v-icon
                                                        >
                                                    </v-flex>
                                                </v-layout>
                                                <v-card-title
                                                    class="text-center teal--text text--lighten-3"
                                                    >{{ $t('msg-introduzca-nombre-subordinado') }}</v-card-title
                                                >
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="dlgSubordinatedError = false"
                                                        >OK</v-btn
                                                    >
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para pedir que se escriba el nombre y las iniciales del subordinado a editar/agregar *********************************** -->

                        <!-- Modal para pedir que se escriba por lo menos un subordinado: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="dlgNoSubordinatedError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/pleaseanswer.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-text
                                                    class="teal--text text--lighten-2 headline text-center"
                                                >
                                                    <img height="90" :src="retroalimentameLogo"/>
                                                    <br />
                                                    <br />
                                                </v-card-text>
                                                <v-layout row justify-center>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-icon x-large color="orange darken-1">mdi-alert-circle-outline</v-icon
                                                        >
                                                    </v-flex>
                                                </v-layout>
                                                <v-card-title
                                                    class="text-center teal--text text--lighten-3"
                                                    >{{ $t('msg-introduzca-por-lo-menos-un-subordinado') }}</v-card-title
                                                >
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="dlgNoSubordinatedError = false"
                                                        >OK</v-btn
                                                    >
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para pedir que se escriba por lo menos un subordinado *********************************** -->

                        <!-- Modal para confirmar el borrado de un subordinado: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="dlgDeletingSubordinated"
                                persistent
                                width="35%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="orange darken-2"
                                        dark
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title"
                                            >{{ $t('btn-borrar-subordinado') }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon
                                                large
                                                color="orange darken-2"
                                                >mdi-alert</v-icon
                                            >
                                        </div>
                                        &nbsp; {{ $t('quest-borrar-subordinado') }}
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteSubordinatedConfirmed"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteSubordinated"
                                            >{{ $t('btn-cancelar') }}</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar el borrado de un subordinado *************************** -->

                        <!-- Modal para confirmar que no hay subordinados: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="dlgConfirmNoSubordinated"
                                persistent
                                width="35%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="orange darken-2"
                                        dark
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title">{{ $t('lbl-hay-subordinados') }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon
                                                large
                                                color="orange darken-2"
                                                >mdi-alert</v-icon
                                            >
                                        </div>
                                        &nbsp; {{ $t('quest-borrar-subordinados') }}
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmNoSubordinated"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelNoSubordinated"
                                            >{{ $t('btn-cancelar') }}</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar que no hay subordinados *************************** -->

                        <!-- Modal para pedir que se contesten todas las preguntas de opción múltiple: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bQuestionNotAnswered"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/pleaseanswer.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-text
                                                    class="teal--text text--lighten-2 headline text-center"
                                                >
                                                    <img height="90" :src="retroalimentameLogo"/>
                                                    <br />
                                                    <br />
                                                </v-card-text>
                                                <v-layout row justify-center>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-icon
                                                            x-large
                                                            color="orange darken-1"
                                                            >mdi-alert-circle-outline
                                                        </v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-card-title
                                                    class="text-center teal--text text--lighten-3"
                                                    >{{ $t('msg-por-favor-conteste-todo') }}</v-card-title
                                                >
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="bQuestionNotAnswered = false"
                                                        >OK</v-btn
                                                    >
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para pedir que se contesten todas las preguntas de opción múltiple *********************************** -->

                        <!-- Modal para pedir que se seleccionen 3 respuestas en una pregunta de selección múltiple: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bUnderSelection"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/pleaseanswer.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-text
                                                    class="teal--text text--lighten-2 headline text-center"
                                                >
                                                    <img height="90" :src="retroalimentameLogo"/>
                                                    <br />
                                                    <br />
                                                </v-card-text>
                                                <v-layout row justify-center>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-icon
                                                            x-large
                                                            color="orange darken-1"
                                                            >mdi-alert-circle-outline
                                                        </v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-card-title
                                                    class="text-center teal--text text--lighten-3"
                                                    >{{ $t('msg-por-favor-seleccione-tres') }}</v-card-title
                                                >
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="bUnderSelection = false"
                                                        >OK</v-btn
                                                    >
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para pedir que se seleccionen 3 respuestas en una pregunta de selección múltiple *********************************** -->

                        <!-- Modal para pedir que se no se seleccionen más de 3 respuestas en una pregunta de selección múltiple: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bOverSelection"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/pleaseanswer.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-text
                                                    class="teal--text text--lighten-2 headline text-center"
                                                >
                                                    <img height="90" :src="retroalimentameLogo"/>
                                                    <br />
                                                    <br />
                                                </v-card-text>
                                                <v-layout row justify-center>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-icon
                                                            x-large
                                                            color="orange darken-1"
                                                            >mdi-alert-circle-outline
                                                        </v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-card-title
                                                    class="text-center teal--text text--lighten-3"
                                                    >{{ $t('msg-por-favor-no-seleccione-mas-de-tres') }}</v-card-title
                                                >
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="bOverSelection = false"
                                                        >OK</v-btn
                                                    >
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para pedir que no se seleccionen más 3 respuestas en una pregunta de selección múltiple *********************************** -->

                        <!-- Modal para pedir que no se escriban más de 2000 caracteres en una pregunta de texto libre: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bOverLength"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/pleaseanswer.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-text
                                                    class="teal--text text--lighten-2 headline text-center"
                                                >
                                                    <img height="90" :src="retroalimentameLogo"/>
                                                    <br />
                                                    <br />
                                                </v-card-text>
                                                <v-layout row justify-center>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-icon
                                                            x-large
                                                            color="orange darken-1"
                                                            >mdi-alert-circle-outline
                                                        </v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-card-title
                                                    class="text-center teal--text text--lighten-3"
                                                    >{{ $t('msg-limite-de-caracteres') }}</v-card-title
                                                >
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="bOverLength = false"
                                                        >OK</v-btn
                                                    >
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para pedir que no se escriban 2000 caracteres en una pregunta de texto libre *********************************** -->


                        <!-- Modal para pedir que vuelva a finalizar la encuesta porque hubo un error de comunicación: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="sendUserSurveyError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/comm-error.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-text class="teal--text text--lighten-2 headline text-center">
                                                    <img height="110" :src="retroalimentameLogo"/>
                                                </v-card-text>
                                                <v-layout row justify-center>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-icon
                                                            x-large
                                                            color="orange darken-1"
                                                            >mdi-alert-outline</v-icon
                                                        >
                                                    </v-flex>
                                                </v-layout>
                                                <v-card-title
                                                    class="text-center teal--text text--lighten-3"
                                                    >{{ $t('msg-error-comunicacion') }}</v-card-title
                                                >
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="onPleaseReSendSurvey"
                                                        >OK
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para pedir que se vuelva a mandar la encuesta porque hubo un error de comunicación con el servidor *********************************** -->

                        <!-- Modal para informar que se terminó el tiempo de la sesión: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="dlgSessionExpired"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-container pa-0>
                                        <v-card class="mx-auto">
                                            <v-img
                                                class="teal--text text--lighten-3 align-end"
                                                src="@/assets/timeout.jpg"
                                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                            >
                                                <v-card-title class="text-center teal--text text--lighten-3">
                                                    {{ $t('msg-tiempo-terminado') }}
                                                </v-card-title>
                                                <v-divider
                                                    class="orange darken-3"
                                                ></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="teal lighten-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSessionExpired"
                                                        >OK
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-img>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termna modal para informar que se terminó el tiempo de la sesión *********************************** -->
                    </v-container>
                    <!-- Termina container para contenido principal -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- </v-parallax> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash'; //Para ordenamiento de arreglos.
import goTo from 'vuetify/es5/services/goto'; //Para scroll

export default {
    name: 'Languages',
    data() {
        return {
            bDense: true,
            drawer: false,
            bEdit: false,
            bNew: false,
            bInvalidData: false,
            errorMessage: '',
            bShowDisclaimer: false,
            bHideIntro: false, //Indica si ya no se debe volver a desplegar la Introducción, en caso de haber.
            bDlgAskForName: false, //Indica si se debe pedir nombre para el reporte (cuando es una encuesta masiva).
            bQuestionNotAnswered: false, //Indica si el usuario dejó una pregunta de opción múltiple sin contestar.
            bUnderSelection: false, //Indica que en una pregunta de selección múltiple el usuario no ha seleccionado 3 respuestas.
            bOverSelection: false, //Indica que en una pregunta de selección múltiple el usuario seleccionó más de 3 respuestas.
            iMaxCharacters: 2000,
            bOverLength: false, //Indica que en una pregunta de texto libre se escribieron más de iMaxCharacters.

            surveyProgress: 0, //Porcentaje de avance de la encuesta.

            subordinatedAsked: false, //Para saber si ya se preguntó si se desea evaluar a subordinados.
            subordinatedDlg: false, //Para desplegar un modal preguntando si hay subordinados y cuántos son.
            subordinatedArrayModified: false, //Indica si el arreglo de preguntas para los subordinados ya fue modificado.
            subordinated: '1', //Indica si se desea evaluar a subordinados (por default "1").
            subordinatedArray: [], //Arreglo de subordinados a evaluar.
            subordinatedHeader: [
                {
                    text: 'Nombre completo',
                    value: 'name',
                    align: 'start',
                    sortable: false,
                    divider: true,
                    width: '80%',
                },
                {
                    text: 'Iniciales',
                    value: 'initials',
                    align: 'start',
                    sortable: false,
                    divider: true,
                    width: '20%',
                },
            ],
            addSubordinatedDlg: false, //Para desplegar un modal para agregar o editar un subordinado.
            subordinatedToAdd: {
                //Objeto para agregar o editar un subordinado.
                ID: 0,
                name: '',
                initials: '',
            },
            selectedSubordinated: [], //Subordinado seleccionado para editar o borrar
            dlgSubordinatedError: false,
            dlgNoSubordinatedError: false,
            dlgDeletingSubordinated: false,
            dlgConfirmNoSubordinated: false,

            nextModule: 0,
            nextQuestionGroup: 0,
            nextQuestionIndex: 0, //Indice de la siguiente pregunta a mostrar al hacer click en el botón "Siguiente". Va de 0 al número de preguntas del grupo actual menos uno.
            lastModule: 0,
            lastQuestionGroup: 0,
            lastQuestionIndex: 0, //Indice de la última pregunta mostrada.

            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            questionsToShow: [], //Arreglo de máximo 6 preguntas, que son las que se pueden mostrar a la vez.
            bShowNextButton: false,
            bShowPrevButton: false,
            moduleTitle: '',
            groupTitle: '',

            timeLeft: 0, //Tiempo máximo de la sesión en segundos.
            dlgSessionExpired: false,
            bSurveySent: false, //Para deshabilitar el botón "Finalizar Encuesta"

            commentLengthRules: [v => v.length <= 2000 || 'Máximo 2000 caracteres'],
        };
    },
    components: {},
    created() {
        console.log('surveyCompany = ', this.surveyCompany);
        console.log('userSurveyData = ', this.userSurveyData);
        
        this.sessionExpires = this.userSurveyData.expira;
        this.timeLeft = this.userSurveyData.expiraMinutos * 60;
        this.sessionEnded = false;
        this.sessionEnding = false;
        this.sessionTimeLeft = "";

        console.log("Created, sessionExpires = ", this.sessionExpires);
        console.log("Created, timeLeft = ", this.timeLeft);
        console.log("Created, sessionTimeLeft = ", this.sessionTimeLeft);

        //console.log('breakpoints: ', this.$vuetify.breakpoint);
        // console.log(
        //     'Preguntas del módulo actual: ',
        //     this.userSurveyData.modulos[this.nextModule].gruposPreguntas[
        //         this.nextQuestionGroup
        //     ]
        //);
        window.addEventListener('beforeunload', (event) => {
            // Cancel the event as stated by the standard.
            // event.preventDefault();
            // Chrome requires returnValue to be set.
            //event.returnValue = '';
            window.alert('Saliendo');
            console.log('Saliendo...');
            this.$store.dispatch('testExit');
        });

        this.bShowDisclaimer = true;

        this.createQuestionsToShow();
    },
    beforeDestroy() {
        console.log('beforeDestroy...');
    },
    methods: {
        onCloseDisclaimer() {
            this.bShowDisclaimer = false;
        },

        startTimer()
        {
            var minLeft = parseInt(this.timeLeft / 60);//ParseInt para quitar los decimales.
            var secLeft = this.timeLeft % 60;
            if (secLeft < 10)
            {
                secLeft = "0" + secLeft;
            }

            if (this.timeLeft < 120)
            {
                this.sessionEnding = true;

                if (this.sessionTimeLeft % 2 === 0)
                {
                    this.timeLeft --;
                    this.sessionTimeLeft = "Tiempo restante: " + minLeft + ":" + secLeft;
                }
                else //Para que parpadee...
                {
                    this.sessionTimeLeft = "";
                }
                if ((this.timeLeft > 0) && (!this.sessionEnded))
                {
                    setTimeout(()=>{ this.startTimer()}, 500);
                }
                else
                {
                    this.sessionTimeLeft = "Tiempo restante: 00:00";
                    this.dlgSessionExpired = true;
                }
            }
            else
            {
                this.timeLeft --;
                this.sessionTimeLeft = "Tiempo restante: " + minLeft + ":" + secLeft;
                if (!this.sessionEnded)
                {
                    setTimeout(()=>{ this.startTimer()}, 1000);
                }
            }

            if (this.timeLeft == 0)
            {
                this.dlgSessionExpired = true;
                this.sessionTimeLeft = "Tiempo restante: " + minLeft + ":" + secLeft;
                //PENDIENTE: Request para enviar la encuesta como se quedó.
                
            }
            // else
            // {
            //     setTimeout(()=>{ this.startTimer()}, 1000);
            // }
        },

        onSessionExpired()
        {
            //Checar si está bien llamar a logout o es mejor usar otro método que en store.js
            //también redireccione a /sign-in, ya que el request para cerrar la sesión ya se debió
            //haber mandado desde antes, en la función startTimer(). Aquí sólo se tiene que cerrar
            //la ventana:
            this.dlgSessionExpired = false;
            this.$store.dispatch('logout');
        },

        onBegin() {
            this.bHideIntro = true;

            if (this.userSurveyData.pedirNombre)
            {
                this.bDlgAskForName = true;
            }
            else
            {
                this.startAnswering();
            }
        },

        startAnswering() {
            if (this.sessionExpires)
            {
                this.startTimer();
            }
        },

        confirmUserName() {
            this.bDlgAskForName = false;
            this.$store.dispatch('updateUserSurveyName', this.userSurveyData.nombre + " " + this.userSurveyData.apellido);
            this.startAnswering();
        },

        onExit() {
            this.sessionEnded = true;
            this.$store.dispatch('logout');
        },

        onSend() {
            //Valida que se hayan contestado todas las preguntas de opción múltiple de la última ventana:
           
            for (let i = 0; i < this.questionsToShow.length; i++) {
                if (this.questionsToShow[i].tipo === 1 || this.questionsToShow[i].tipo === 2)
                {
                    if (this.questionsToShow[i].respuestaUsuario === 0) {
                        this.bQuestionNotAnswered = true;
                        break;
                    }
                }
                else //Valida que se hayan seleccionado 3 respuestas si la pregunta es de selección múltiple:
                if (this.questionsToShow[i].tipo === 5)
                {
                    var iSeleccion = 0;
                    for(let j = 0; j < this.questionsToShow[i].respuestas.length; j ++)
                    {
                        if (this.questionsToShow[i].respuestas[j].respuesta === true)
                        {
                            iSeleccion ++;
                        }
                    }
                    if (iSeleccion < 3)
                    {
                        this.bUnderSelection = true;
                        break;
                    }
                    else
                    if (iSeleccion > 3)
                    {
                        this.bOverSelection = true;
                        break;
                    }
                }
                else //Valida que si la pregunta es de texto libre no tenga más de 2000 caracteres:
                if (this.questionsToShow[i].tipo === 4)
                {
                    if (this.questionsToShow[i].respuestas[0].respuesta.length > this.iMaxCharacters)
                    {
                        this.bOverLength = true;
                        break;
                    }
                }

            }
            

            if (!this.bQuestionNotAnswered && !this.bOverSelection && !this.bUnderSelection && !this.bOverLength)
            {
                console.log('Enviando encuesta, userSurveyData = ', this.userSurveyData);
                this.bSurveySent = true; //Para deshabilitar el botón "Finalizar Encuesta"
                this.$store.dispatch('sendUserSurvey');
            }
        },

        onPleaseReSendSurvey()
        {
            this.sendUserSurveyError = false;
            this.bSurveySent = false;
        },

        onSelectAnswer({ answer, question }) {
            //console.log('answer = ', answer);
            //console.log('question = ', question);

            var i;
            for (i = 0; i < question.respuestas.length; i++) {
                if (question.respuestas[i].num === answer.num) {
                    question.respuestas[i].respuesta = '1';
                } else {
                    question.respuestas[i].respuesta = '0';
                }
            }

            //console.log('question = ', question);
        },

        createQuestionsToShow() {
            var bCreateQuestions = true;

            //****************************

            //Se checa si el módulo es para evaluar subordinados y el módulo con las preguntas de los subordinados no se ha construido todavía:
            if (this.userSurveyData.modulos[this.nextModule].evaluarSubordinados === 1 && this.subordinatedArrayModified === false)
            {
                bCreateQuestions = false;

                //Primero se checa si no se ha preguntado todavía si se desea evaluar subordinados o no:
                if (this.subordinatedAsked === false)
                {
                    //Se despliega un mensaje preguntando si se desea evaluar a los subordinados:
                    this.subordinatedASked = true;
                    this.subordinatedDlg = true;
                }
                //Ya se preguntó si se desea evaluar a los subordinados. Se checa si hay que
                //modificar el arreglo gruposPreguntas del módulo (si sí se va a evaluar a
                //subordinados y no se ha modificado el arreglo todavía)
                else
                if (this.subordinatedArrayModified === false && this.subordinatedArray.length > 0 )
                {
                    //Sí se va a evaluar a subordinados...

                    //Se cambia el número de preguntas totales de la encuesta, con base en el número de subordinados y en el número de preguntas
                    //del módulo (a subordinatedArray se le resta 1, ya que cuando se calculó originalmente el total de preguntas ya se incluyó el
                    //número de preguntas del módulo una vez):
                    this.surveyNumQuestions =
                        this.surveyNumQuestions +
                        (this.subordinatedArray.length - 1) *
                            this.userSurveyData.modulos[this.nextModule]
                                .gruposPreguntas[0].preguntas.length;

                    var gruposPreguntas = []; //Arreglo que sustituirá al arreglo gruposPreguntas original del módulo.
                    var numGrupo = 1;
                    var tituloGrupo = '';

                    //Plantilla de preguntas para todos los grupos de preguntas:
                    const questionTemplate = this.userSurveyData.modulos[this.nextModule].gruposPreguntas[0].preguntas;

                    //Obtiene el número general de la primera pregunta del módulo:

                    var numGral = this.userSurveyData.modulos[this.nextModule].gruposPreguntas[0].preguntas[0].numGral;

                    //Crea un grupo de preguntas para cada subordinado:
                    var x;

                    for (x = 0; x < this.subordinatedArray.length; x++)
                    {
                        var grupoPreguntas = {
                            numGrupo: x + 1,
                            tituloGrupo: this.subordinatedArray[x].name + "[" + this.subordinatedArray[x].initials,
                            preguntas: JSON.parse(JSON.stringify(questionTemplate))
                        };

                        //En cada pregunta cambia "XXX" por el nombre de cada subordinado:
                        var y;
                        for (y = 0; y < grupoPreguntas.preguntas.length; y++)
                        {
                            grupoPreguntas.preguntas[y].pregunta = grupoPreguntas.preguntas[y].pregunta.replace('XXX', this.subordinatedArray[x].name);
                            grupoPreguntas.preguntas[y].numGral = numGral;

                            numGral++;
                        }
                        gruposPreguntas.push(grupoPreguntas);
                    }

                    //Reemplaza el arreglo de grupos de preguntas original por el nuevo arreglo:
                    this.userSurveyData.modulos[
                        this.nextModule
                    ].gruposPreguntas = gruposPreguntas;

                    this.subordinatedArrayModified = true;
                    bCreateQuestions = true;
                }
            }

            if (bCreateQuestions) {
                //****************************
                //Genera un bloque de máximo 6 preguntas, que son las que se pueden mostrar a la vez:
                var bEndReached = false; //Indica si ya se terminó de recorrer todo el arreglo de preguntas.

                var iQuestions = 0;
                this.questionsToShow = [];
                var i;
                var numQuestions = 0;

                //console.log('Al iniciar creatQuestionsToShow, nextQuestionIndex = ', this.nextQuestionIndex);

                //console.log('userSurveyData.modulos = ', this.userSurveyData.modulos);
                //console.log('nextModule = ', this.nextModule);
                //console.log('nextQuestionGroup = ', this.nextQuestionGroup);
                //console.log('Empezando en ', this.userSurveyData.modulos[this.nextModule].gruposPreguntas);

                var currentWndQuestions = 0; //Número de preguntas de la ventana actual
                var lastQuestionNumber = 0; //Número general de la última pregunta

                for (
                    i = this.nextQuestionIndex;
                    i <
                    this.userSurveyData.modulos[this.nextModule]
                        .gruposPreguntas[this.nextQuestionGroup].preguntas
                        .length;
                    i++
                ) {
                    currentWndQuestions++;
                    lastQuestionNumber = this.userSurveyData.modulos[this.nextModule].gruposPreguntas[this.nextQuestionGroup].preguntas[i].numGral;

                    this.lastQuestionIndex = this.nextQuestionIndex;
                    this.lastQuestionGroup = this.nextQuestionGroup;
                    this.lastModule = this.nextModule;

                    this.moduleTitle = this.userSurveyData.modulos[this.nextModule].tituloModulo;
                    this.groupTitle = this.userSurveyData.modulos[this.nextModule].gruposPreguntas[this.nextQuestionGroup].tituloGrupo;

                    var tempQuestion = this.userSurveyData.modulos[this.nextModule].gruposPreguntas[this.nextQuestionGroup].preguntas[i];
                    var question = {
                        numPregunta: tempQuestion.numPregunta,
                        pregunta: tempQuestion.pregunta,
                        tipo: tempQuestion.tipo,
                        respuestas: tempQuestion.respuestas,
                        respuestaUsuario: 0, //Se agrega para asociar al v-model del radio
                    };

                    //Checa si la pregunta ya tiene alguna respuesta seleccionada por el usuario:
                    var j;
                    for (j = 0; j < tempQuestion.respuestas.length; j++)
                    {
                        if (tempQuestion.respuestas[j].respuesta === '1')
                        {
                            question.respuestaUsuario = tempQuestion.respuestas[j].num;
                            break;
                        }
                    }
                    this.questionsToShow.push(question);
                    this.nextQuestionIndex++;
                    numQuestions++;

                    //console.log('nextQuestionIndex = ', this.nextQuestionIndex);

                    //Sólo se despliegan 6 preguntas por ventana:
                    if (numQuestions > 5) {
                        break;
                    }
                }

                this.surveyProgress = ((lastQuestionNumber - currentWndQuestions) / this.surveyNumQuestions) * 100;

                //Se dejan los índices preparados para la próxima vez que se presione el botón "Continuar":

                //Se checa si ya se terminó el grupo de preguntas actual y la encuesta:
                this.bShowNextButton = true;
                //console.log('Antes de checar si ya se terminó el grupo de preguntas actual, nextQuestionIndex = ', this.nextQuestionIndex);
                if (this.nextQuestionIndex + 1 > this.userSurveyData.modulos[this.nextModule].gruposPreguntas[this.nextQuestionGroup].preguntas.length)
                {
                    //Cambio de Grupo de preguntas:
                    this.nextQuestionIndex = 0;
                    this.nextQuestionGroup++;

                    //Se checa si se terminaron todas las preguntas del grupo de preguntas, se pasa al siguiente módulo:
                    if (this.nextQuestionGroup + 1 > this.userSurveyData.modulos[this.nextModule].gruposPreguntas.length)
                    {
                        //Cambio de Módulo:
                        //console.log('Se terminaron todas las preguntas del grupo...');
                        this.nextQuestionGroup = 0;
                        this.nextModule++;

                        //Se checa si ya se terminaron de recorrer todos los módulos:
                        //console.log('nextModule = ', this.nextModule);
                        //console.log('userSurveyData.modulos = ', this.userSurveyData.modulos);
                        if (this.nextModule + 1 > this.userSurveyData.modulos.length)
                        {
                            //console.log('Se terminaron todos los módulos...');
                            this.bShowNextButton = false;

                            //Como ya estamos en la última ventana de la encuesta, se pone el avance en 100%:
                            this.surveyProgress = 100;
                        }
                    }
                }

                //Se checa si se debe habilitar el botón "Regresar"
                if (this.nextModule === 0 && this.nextQuestionGroup === 0 && this.nextQuestionIndex < 7)
                {
                    this.bShowPrevButton = false;
                }
                else
                {
                    this.bShowPrevButton = true;
                }

                goTo(0); //Scroll hasta arriba.
            }
        },

        onNext() {
            //Valida que se hayan contestado todas las preguntas de opción múltiple de la ventana:
            console.log('onNext(), questionsToShow = ', this.questionsToShow);
            for (let i = 0; i < this.questionsToShow.length; i++)
            {
                if (this.questionsToShow[i].tipo === 1 || this.questionsToShow[i].tipo === 2)
                {
                    if (this.questionsToShow[i].respuestaUsuario === 0)
                    {
                        this.bQuestionNotAnswered = true;
                        break;
                    }
                }
                else //Valida que se hayan seleccionado 3 respuestas si la pregunta es de selección múltiple:
                if (this.questionsToShow[i].tipo === 5)
                {
                    var iSeleccion = 0;
                    for(let j = 0; j < this.questionsToShow[i].respuestas.length; j ++)
                    {
                        if (this.questionsToShow[i].respuestas[j].respuesta === true)
                        {
                            iSeleccion ++;
                        }
                    }
                    if (iSeleccion < 3)
                    {
                        this.bUnderSelection = true;
                        break;
                    }
                    else
                    if (iSeleccion > 3)
                    {
                        this.bOverSelection = true;
                        break;
                    }
                }
                else //Valida que si la pregunta es de texto libre no tenga más de 2000 caracteres:
                if (this.questionsToShow[i].tipo === 4)
                {
                    if (this.questionsToShow[i].respuestas[0].respuesta.length > this.iMaxCharacters)
                    {
                        this.bOverLength = true;
                        break;
                    }
                }
            }

            if (!this.bQuestionNotAnswered && !this.bOverSelection && !this.bUnderSelection && !this.bOverLength)
            {
                this.createQuestionsToShow();
            }
        },

        onPrev() {
            //Si el índice de la última pregunta es mayor a 5, no hay que cambiar de grupo ni de módulo,
            //nada más hay que disminuir el índice de la pregunta:
            if (this.lastQuestionIndex > 5) {
                //Hay que moverse al inicio de la ventana anterior. Para esto, se va decrementando el índice de la
                //pregunta hasta que es múltiplo de 6, y cuando se llega a este valor, al índice se le restan 6.
                //Esto coloca el índice al inicio de la ventana anterior.
                var i;
                for (i = this.lastQuestionIndex; i > 0; i--)
                {
                    var iResidue = i % 6;
                    if (iResidue === 0)
                    {
                        break;
                    }
                }

                //this.nextQuestionIndex = this.lastQuestionIndex - 6;
                this.nextQuestionIndex = i - 6;
                this.nextQuestionGroup = this.lastQuestionGroup;
                this.nextModule = this.lastModule;
            } //lastQuestionIndex < 5
            else {
                //Hay que checar si se debe cambiar a un grupo anterior o a un módulo anterior:
                if (this.lastQuestionGroup > 0) {
                    //Permanece en el mismo módulo, pero se baja al grupo de preguntas anterior (a la última ventana del grupo):
                    this.nextModule = this.lastModule;
                    this.nextQuestionGroup = this.lastQuestionGroup - 1;

                    //Se posiciona al principio del último bloque de preguntas del grupo:
                    var numberOfQuestions = this.userSurveyData.modulos[this.nextModule].gruposPreguntas[this.nextQuestionGroup].preguntas.length;

                    var windowIndex = (numberOfQuestions - 1) / 6;
                    windowIndex = Math.floor(windowIndex);
                    //console.log('numberOfWidows = ', windowIndex);

                    this.nextQuestionIndex = windowIndex * 6;

                    //console.log('windowIndex = ', windowIndex);
                    //console.log('nextQuestionIndex = ', this.nextQuestionIndex);
                } //lastQuetionGroup === 0
                else {
                    //Se disminuye el módulo. Hay que moverse al principio del último grupo del módulo anterior:
                    this.nextModule = this.lastModule - 1;
                    this.nextQuestionGroup = this.userSurveyData.modulos[this.nextModule].gruposPreguntas.length - 1;

                    //Se posiciona en la última ventana del grupo. Para esto, primero se posiciona en la última pregunta,
                    //y se va decrementando el índice de la pregunta hasta que sea múltiplo de 6.
                    //Esto coloca el índice al inicio de la última ventana del grupo.
                    var i;
                    for (i = this.userSurveyData.modulos[this.nextModule].gruposPreguntas[this.nextQuestionGroup].preguntas.length - 1; i > 0; i --)
                    {
                        var iResidue = i % 6;
                        if (iResidue === 0)
                        {
                            break;
                        }
                    }

                    this.nextQuestionIndex = i;
                }
            }
            this.createQuestionsToShow();
        },
        onUp(question, answer) {
            var selectedAnswerNum = parseInt(answer.respuesta);
            var newSelectedAnswerNum = selectedAnswerNum - 1;
            //console.log('selectedAnswerNum = ', selectedAnswerNum);
            //console.log('newSelectedAnswerNum = ', newSelectedAnswerNum);

            var i;
            for (i = 0; i < question.respuestas.length; i++) {
                var answerNum = parseInt(question.respuestas[i].respuesta);

                //Si es la respuesta a editar, se baja su índice:
                if (answerNum === selectedAnswerNum)
                {
                    question.respuestas[i].respuesta = newSelectedAnswerNum.toString();
                }
                //Si la respuesta tiene el mismo índice que el nuevo índice de la respuesta seleccionada
                //se aumenta su índice, para recorrerla:
                else if (answerNum === newSelectedAnswerNum)
                {
                    answerNum ++;
                    question.respuestas[i].respuesta = answerNum.toString();
                }
            }
            //console.log('question = ', question);
        },
        onDown(question, answer) {
            var selectedAnswerNum = parseInt(answer.respuesta);
            var newSelectedAnswerNum = selectedAnswerNum + 1;
            //console.log('selectedAnswerNum = ', selectedAnswerNum);
            //console.log('newSelectedAnswerNum = ', newSelectedAnswerNum);

            var i;
            for (i = 0; i < question.respuestas.length; i++) {
                var answerNum = parseInt(question.respuestas[i].respuesta);

                //Si es la respuesta a editar, se baja su índice:
                if (answerNum === selectedAnswerNum)
                {
                    question.respuestas[i].respuesta = newSelectedAnswerNum.toString();
                }
                //Si la respuesta tiene el mismo índice que el nuevo índice de la respuesta seleccionada
                //se aumenta su índice, para recorrerla:
                else if (answerNum === newSelectedAnswerNum)
                {
                    answerNum --;
                    question.respuestas[i].respuesta = answerNum.toString();
                }
            }
            //console.log('question = ', question);
        },

        orderedAnswers(answers) {
            //Ordena el arreglo de respuestas con base en el campo 'respuesta':
            return _.orderBy(answers, 'respuesta');
        },

        onAddSubordinated() {
            this.selectedSubordinated = []; //Se deselecciona el subordinado seleccionado, si lo hay.
            this.subordinatedToAdd.ID = 0;
            this.subordinatedToAdd.name = '';
            this.subordinatedToAdd.initials = '';
            this.addSubordinatedDlg = true;
        },

        onEditSubordinated() {
            this.subordinatedToAdd.ID = this.selectedSubordinated[0].ID;
            this.subordinatedToAdd.name = this.selectedSubordinated[0].name;
            this.subordinatedToAdd.initials = this.selectedSubordinated[0].initials;
            this.addSubordinatedDlg = true;
        },

        onDeleteSubordinated() {
            this.dlgDeletingSubordinated = true;
        },

        deleteSubordinatedConfirmed() {
            var i;
            for (i = 0; i < this.subordinatedArray.length; i++)
            {
                if (this.subordinatedArray[i].ID === this.selectedSubordinated[0].ID)
                {
                    this.subordinatedArray.splice(i, 1);
                    break;
                }
            }

            this.selectedSubordinated = [];
            this.dlgDeletingSubordinated = false;
        },

        cancelDeleteSubordinated() {
            this.dlgDeletingSubordinated = false;
        },

        onSubordinatedOK() {
            //Si no hay subordinados, se borran las preguntas restantes:
            if (this.subordinated === '0')
            {
                console.log('onSubordinatedOK, userSurveyData.modulos = ', this.userSurveyData.modulos);
                console.log('nextModule = ', this.nextModule);

                // this.userSurveyData.modulos[
                //     this.nextModule
                // ].evaluarSubordinados = 0;

                //Se le resta al número total de preguntas el número de preguntas del módulo de subordinados, el cual se va a eliminar:
                this.surveyNumQuestions = this.surveyNumQuestions - this.userSurveyData.modulos[this.nextModule].gruposPreguntas[0].preguntas.length;

                this.surveyProgress = 100;

                this.userSurveyData.modulos.splice(this.nextModule, 1);

                this.subordinatedDlg = false;
                this.bShowNextButton = false;
            }
            //Sí hay subordinados...
            else if (this.subordinated === '1') {
                if (this.subordinatedArray.length === 0)
                {
                    this.dlgNoSubordinatedError = true;
                }
                else
                {
                    this.subordinatedAsked = true;
                    this.subordinatedDlg = false;
                    //console.log('A punto de llamar a createQuestionsToShow desde onSubordinatedOK');
                    this.createQuestionsToShow();
                }
            }
        },
        onConfirmSubordinatedEdition()
        {
            if (this.subordinatedToAdd.name === '' || this.subordinatedToAdd.initials === '')
            {
                this.dlgSubordinatedError = true;
            }
            else
            {
                if (this.subordinatedToAdd.ID === 0)
                {
                    //Agregar subordinado...
                    this.subordinatedToAdd.ID = this.subordinatedArray.length + 1;
                    this.subordinatedArray.push(this.subordinatedToAdd);
                } //Edición de subordinado...
                else
                {
                    //Edición de subordinado...
                    var i;
                    for (i = 0; i < this.subordinatedArray.length; i++)
                    {
                        if (this.subordinatedArray[i].ID === this.subordinatedToAdd.ID)
                        {
                            this.subordinatedArray[i].name = this.subordinatedToAdd.name;
                            this.subordinatedArray[i].initials = this.subordinatedToAdd.initials;
                            break;
                        }
                    }
                }
                this.subordinatedToAdd = {
                    ID: 0,
                    name: '',
                    initials: '',
                };
                this.addSubordinatedDlg = false;
            }
        },

        onCancelSubordinatedEdition()
        {
            this.subordinatedToAdd = {
                ID: 0,
                name: '',
                initials: '',
            };
            this.addSubordinatedDlg = false;
        },
        onNoSubordinated() {
            //Si hay por lo menos un subordinado registrado, pregunta si se desea borrar a los
            //subordinados registrados:
            if (this.subordinatedArray.length > 0) {
                this.dlgConfirmNoSubordinated = true;
            }
        },
        onConfirmNoSubordinated() {
            this.subordinatedArray = [];
            this.dlgConfirmNoSubordinated = false;
        },
        onCancelNoSubordinated() {
            this.subordinated = '1';
            this.dlgConfirmNoSubordinated = false;
        },
        privacy(){
             //window.open("https://www.twmexico.com/politica-de-privacidad.htm");
             window.open("https://www.retroalimentame.com.mx/PDF/AvisoPrivacidad.pdf");
        }
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'retroalimentameLogo',
            'disclaimerImg',
            'userName',
            'surveyCompany',
            'companyLogoImg',
            'userSurveyData',
            'surveyNumQuestions',
        ]),

        // timeLeftToPrint() {
        //     var minLeft = parseInt(this.timeLeft / 60); //ParseInt para quitar los decimales.
        //     var secLeft = this.timeLeft % 60;
        //     if (secLeft < 10)
        //     {
        //         secLeft = "0" + secLeft;
        //     }

        //     return minLeft + ":" + secLeft;
        // },

        showIntro() {
            var bShowIntro = false;
            if (this.userSurveyData.intro !== '' && !this.bHideIntro) {
                bShowIntro = true;
            }
            return bShowIntro;
        },

        companyName() {
            var strName = '';
            if (this.surveyCompany !== null) {
                strName = this.surveyCompany.empresanombre;
            }
            return strName;
        },

        selectedLanguageIndex: {
            get() {
                return this.$store.getters.selectedLanguageIndex;
            },
            set(selectedLanguageIndex) {
                this.$store.dispatch(
                    'updateSelectedLanguageIndex',
                    selectedLanguageIndex
                );
            },
        },

        surveyNumQuestions: {
            get() {
                return this.$store.getters.surveyNumQuestions;
            },
            set(surveyNumQuestions) {
                this.$store.dispatch(
                    'updateSurveyNumQuestions',
                    surveyNumQuestions
                );
            },
        },

        sendUserSurveyError: {
            get() {
                return this.$store.getters.sendUserSurveyError;
            },
            set(sendUserSurveyError) {
                this.$store.dispatch(
                    'updateSendUserSurveyError',
                    sendUserSurveyError
                );
            },
        },

        sessionExpires: {
            get() {
                return this.$store.getters.sessionExpires;
            },
            set(sessionExpires) {
                this.$store.dispatch('updateSessionExpires', sessionExpires);
            },
        },

        sessionTimeLeft: {
            get() {
                return this.$store.getters.sessionTimeLeft;
            },
            set(sessionTimeLeft) {
                this.$store.dispatch('updateSessionTimeLeft', sessionTimeLeft);
            },
        },

        sessionEnding: {
            get() {
                return this.$store.getters.sessionEnding;
            },
            set(sessionEnding) {
                this.$store.dispatch(
                    'updateSessionEnding',
                    sessionEnding
                );
            },
        },

        sessionEnded: {
            get() {
                return this.$store.getters.sessionEnded;
            },
            set(sessionEnded) {
                this.$store.dispatch(
                    'updateSessionEnded',
                    sessionEnded
                );
            },
        },

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '75%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '65%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '60%';
            }
            return width;
        },

        disclaimerWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '75%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '40%';
            }
            return width;
        },

        miniModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '45%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '35%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '30%';
            }
            return width;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '35%';
            }
            return width;
        },

        nameReportModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '50';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '60';
            } else if (this.$vuetify.breakpoint.md) {
                height = '70';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },

        disclaimerImgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '440px';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '410px';
            } else if (this.$vuetify.breakpoint.md) {
                width = '380px';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '350px';
            } else {
                width = '320px';
            }
            return width;
        },
    },
};
</script>

<style scoped>

.tw-green {
    color: #00897b;
    /* teal darken-1 */
}
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.85);
}
.user-survey {
    background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

.enter-line {
    white-space: pre-wrap;
}

a:link,
a:visited {
    color: #26a69a;
    text-decoration: none;
}

a:link:active,
a:visited:active {
    color: #26a69a;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>